import { Observable } from 'rxjs';
import { IContractSignature } from '../models/IContractSignature';

/**
 * Interface genérica para dados de entrada do componente de contrato
 */
export interface IContractDialogData<T = any> {
    /** Entidade para a qual o contrato será gerado (cliente, parceiro, etc.) */
    entity: T;
    /** Tipo da entidade: 'customer' | 'partner' | 'consultant' etc. */
    entityType: ContractEntityType;
    /** Planos disponíveis para a entidade (opcional) */
    plans?: any[];
}

/**
 * Tipos de entidade suportados para geração de contrato
 */
export type ContractEntityType = 'customer' | 'partner' | 'consultant' | 'representative' | 'counter' | 'unit';

/**
 * Interface para dados de geração de contrato
 */
export interface IContractGenerationData {
    /** ID da entidade principal */
    entityId: string;
    /** Tipo da entidade */
    entityType: ContractEntityType;
    /** ID do plano selecionado */
    planId?: string;
    /** ID do sistema */
    systemId?: string;
    /** IDs de pessoas relacionadas */
    partnerId?: string;
    consultantId?: string;
    representativeId?: string;
    counterId?: string;
    unitId?: string;
    /** Assinaturas adicionais */
    additionalSigners: IContractSignature[];
    /** Conteúdo HTML customizado (opcional) */
    htmlContent?: string;
    /** Flag para usar template customizado */
    useCustomTemplate?: boolean;
}

/**
 * Interface para plano genérico com informações de contrato
 */
export interface IContractablePlan {
    id: string;
    active: boolean;
    canceledAt: Date | null;
    system?: {
        id: string;
        name: string;
        contractTemplateId?: string;
    };
    /** Indica se já existe um contrato para este plano */
    hasContract?: boolean;
    /** ID do contrato existente */
    contractId?: string;
    /** Status do contrato existente */
    contractStatus?: string;
    /** Indica se o contrato pode ser removido */
    canRemoveContract?: boolean;
}

/**
 * Interface abstrata para serviço de entidade que suporta contratos
 */
export interface IContractableEntityService<T = any> {
    /**
     * Obtém uma entidade por ID com todas as informações necessárias
     */
    get(id: string): Observable<T>;

    /**
     * Obtém os planos disponíveis para a entidade
     */
    getPlans(entityId: string): Observable<IContractablePlan[]>;

    /**
     * Obtém informações de pessoas relacionadas à entidade
     */
    getRelatedPersons(entityId: string): Observable<IRelatedPersons>;
}

/**
 * Interface para pessoas relacionadas à entidade
 */
export interface IRelatedPersons {
    partner?: any;
    consultant?: any;
    representative?: any;
    counter?: any;
    unit?: any;
    [key: string]: any;
}

/**
 * Configuração para o componente de contrato
 */
export interface IContractComponentConfig {
    /** Título do modal */
    title?: string;
    /** Permitir edição de template */
    allowTemplateEdit?: boolean;
    /** Tipos de assinatura excluídos */
    excludedSignatureTypes?: string[];
    /** Adicionar automaticamente assinaturas de pessoas relacionadas */
    autoAddRelatedSignatures?: boolean;
    /** Adicionar automaticamente contratada padrão */
    autoAddDefaultContracted?: boolean;
    /** Adicionar automaticamente usuário atual */
    autoAddCurrentUser?: boolean;
}


